export const STATUS_COLORS = {
  pending: "gold",
  approved: "green",
  rejected: "red",
  suspended: "default",
};

export const STATUS_LABELS = {
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
  suspended: "Suspended",
};
